import {getEnv} from '@/config/environment';
import getCookieValue from './getCookieValue';

export default function getLtid() {
  const ltId = getCookieValue(`cwa_${getEnv().MODE}__lt_id`);
  return ltId ?? null;
}
